import { IconContent } from '@icons';

export const mail: IconContent = {
    md: '<path fill-rule="evenodd" d="M5 7.837V6h14v1.601l-7.059 3.891L5 7.837ZM5 8.97V18h14V8.736l-6.818 3.758-.24.132-.239-.126L5 8.97ZM4 19V5h16v14H4Z" />',
};
